import PaxIcon from "@mui/icons-material/AirlineSeatReclineNormal";
import BaseTag from "./BaseTag";

const PaxTag = (props) => <BaseTag icon={<PaxIcon />} label={props.value} />;

export default PaxTag;
